export default __webpack_public_path__ + "static/media/thrive-logo.2b081992.svg";